export default function (_this) {
  return {
    create (data, callback) {
      let widgetKey
      // let dataKey

      function createWidget (resolve) {
        let newWidget = {
          template: '',
          gsOptions: data.gsOptions,
          tab: data.tab,
          subtab: data.subtab || null,
        }
        
        widgetKey = _this.getRef('widgets')
          .push(newWidget, (snapshot) => {
            resolve()
          }).key
      }

      function insertDeps () {
        return new Promise((resolve) => {
          _this.getRef('widgets/' + widgetKey + '/dependencies/pivottables')
            .set(widgetKey, () => {
              resolve()
            })
        })
      }

      function createWidgetData () {
        return new Promise((resolve) => {
          let tableData = {
            dataProvider: data.dataProvider,
            name: data.name
          }
          _this.getRef('widgetsData/pivottables/' + widgetKey)
            .set(tableData, () => (resolve()))
        })
      }

      function fillTemplate () {
        _this.getRef('widgets/' + widgetKey + '/template')
          .set(`<PivotTable data-key="${widgetKey}" />`, () => {
            callback(widgetKey)
          })
      }

      let promise = new Promise((resolve) => {
        createWidget(resolve)
      })

      promise
        .then(() => {
          return insertDeps()
        })
        .then(() => {
          return createWidgetData()
        })
        .then(() => {
          fillTemplate()
        })
    },
    update (data, callback) {
      let promise = new Promise((resolve) => {
        _this.getRef('widgetsData/pivottables/' + data.table + '/dataProvider')
          .set(data.dataProvider, () => (resolve()))
      })

      promise.then(() => {
          _this.getRef('widgetsData/pivottables/' + data.table + '/name')
            .set(data.name, () => (callback()))
      })
    },
    updateOptions (options, table) {
      _this.getRef('widgetsData/pivottables/' + table + '/options').set(JSON.stringify(options))
    }
  }
}
